<template>
  <v-row
    justify="center"
    align="center"
    v-if="visits && visits.data && visits.data.length > 0"
  >
    <v-col cols="12">
      <v-row>
        <v-row justify="center" align="center">
          <v-card
            outlined
            color="transparent"
            class="ma-0 pa-0"
            align="center"
            justify="center"
            align-items="center"
          >
            <v-list-item>
              <h1 class="font-weight-black black--text mr-3">
                {{ visits.data[visits.data.length - 1].nb_rates }}
              </h1>

              <v-col>
                <v-row>
                  <h2 class="font-weight-bold black--text pt-3">
                    ratings this month
                  </h2>
                </v-row>
                <v-row>
                  <p
                    v-if="visits.data[visits.data.length - 2]"
                    class="font-weight-thin"
                  >
                    {{ visits.data[visits.data.length - 2].nb_rates }}
                    ratings last month
                  </p>
                </v-row>
              </v-col>
            </v-list-item>
          </v-card>
        </v-row>

        <v-divider inset vertical></v-divider>

        <v-col justify="center" align="center">
          <v-card outlined color="transparent" class="ma-0 pa-0">
            <v-list-item class="grow">
              <v-list-item-avatar>
                <v-icon
                  v-if="visits.data[visits.data.length - 2]"
                  color="#C6C6C6"
                  x-large
                >
                  {{
                    getArrow(
                      visits.data[visits.data.length - 2].mean,
                      visits.data[visits.data.length - 1].mean
                    )
                  }}
                </v-icon>
                <v-icon v-else color="#C6C6C6" x-large> mdi-minus-box</v-icon>
              </v-list-item-avatar>

              <h1 class="font-weight-black black--text mr-3">
                {{ visits.data[visits.data.length - 1].mean }}/10
              </h1>

              <v-col>
                <v-row>
                  <h3 class="font-weight-bold black--text pt-3">mean rating</h3>
                </v-row>
                <v-row>
                  <p
                    v-if="visits.data[visits.data.length - 2]"
                    class="font-weight-thin"
                  >
                    {{ visits.data[visits.data.length - 2].mean }}/10 last month
                  </p>
                </v-row>
              </v-col>
            </v-list-item>
          </v-card>
          <v-card outlined color="transparent">
            <v-list-item class="grow">
              <v-list-item-avatar>
                <v-icon
                  v-if="visits.data[visits.data.length - 2]"
                  color="#C6C6C6"
                  x-large
                >
                  {{
                    getArrow(
                      visits.data[visits.data.length - 2].nps_score,
                      visits.data[visits.data.length - 1].nps_score
                    )
                  }}
                </v-icon>
                <v-icon v-else color="#C6C6C6" x-large> mdi-minus-box</v-icon>
              </v-list-item-avatar>

              <h1 class="font-weight-black black--text mr-3">
                {{
                  (visits.data[visits.data.length - 1].nps_score * 100).toFixed(
                    1
                  )
                }}%
              </h1>

              <v-col>
                <v-row>
                  <h3 class="font-weight-bold black--text pt-3">NPS score</h3>
                </v-row>
                <v-row>
                  <p
                    v-if="visits.data[visits.data.length - 2]"
                    class="font-weight-thin"
                  >
                    {{
                      (
                        visits.data[visits.data.length - 2].nps_score * 100
                      ).toFixed(1)
                    }}% last month
                  </p>
                </v-row>
              </v-col>
            </v-list-item>
          </v-card>
          <v-card outlined color="transparent">
            <v-list-item class="grow">
              <v-list-item-avatar>
                <v-icon
                  v-if="visits.data[visits.data.length - 2]"
                  color="#C6C6C6"
                  x-large
                >
                  {{
                    getArrow(
                      visits.data[visits.data.length - 2].ces_score,
                      visits.data[visits.data.length - 1].ces_score
                    )
                  }}
                </v-icon>
                <v-icon v-else color="#C6C6C6" x-large> mdi-minus-box</v-icon>
              </v-list-item-avatar>

              <h1 class="font-weight-black black--text mr-3">
                {{
                  (visits.data[visits.data.length - 1].ces_score * 100).toFixed(
                    1
                  )
                }}%
              </h1>

              <v-col>
                <v-row>
                  <h3 class="font-weight-bold black--text pt-3">CES score</h3>
                </v-row>
                <v-row>
                  <p
                    v-if="visits.data[visits.data.length - 2]"
                    class="font-weight-thin"
                  >
                    {{
                      (
                        visits.data[visits.data.length - 2].ces_score * 100
                      ).toFixed(1)
                    }}% last month
                  </p>
                </v-row>
              </v-col>
            </v-list-item>
          </v-card>
        </v-col>

        <v-divider inset vertical></v-divider>
        <v-row align="center" justify="center">
          <v-col>
            <v-col cols="9" lg="9" md="9" sm="9">
              <v-slider
                class="slider"
                style="height: 30px"
                :value="
                  (
                    visits.data[visits.data.length - 1].percent_promoters * 100
                  ).toFixed(1)
                "
                max="100"
                track-color="#E1E4E9"
                thumb-color="#67C851"
                color="#67C851"
                readonly
              >
                <template v-slot:prepend>
                  <v-icon color="#67C851" title="9-10">
                    mdi-emoticon-happy
                  </v-icon>
                </template>

                <template v-slot:append>
                  <span class="font-weight-black black--text">
                    {{
                      (
                        visits.data[visits.data.length - 1].percent_promoters *
                        100
                      ).toFixed(1)
                    }}%
                  </span>
                </template>
              </v-slider>
            </v-col>
            <v-col cols="9" lg="9" md="9" sm="9">
              <v-slider
                class="slider"
                style="height: 30px"
                :value="
                  (
                    visits.data[visits.data.length - 1].percent_neutrals * 100
                  ).toFixed(1)
                "
                max="100"
                track-color="#E1E4E9"
                thumb-color="#F2DD21"
                color="#F2DD21"
                readonly
              >
                <template v-slot:prepend>
                  <v-icon color="#F2DD21" title="7-8">
                    mdi-emoticon-neutral
                  </v-icon>
                </template>

                <template v-slot:append>
                  <span class="font-weight-black black--text">
                    {{
                      (
                        visits.data[visits.data.length - 1].percent_neutrals *
                        100
                      ).toFixed(1)
                    }}%
                  </span>
                </template>
              </v-slider>
            </v-col>
            <v-col cols="9" lg="9" md="9" sm="9">
              <v-slider
                class="slider"
                style="height: 30px"
                :value="
                  (
                    visits.data[visits.data.length - 1].percent_detractors * 100
                  ).toFixed(1)
                "
                max="100"
                track-color="#E1E4E9"
                thumb-color="#FF2626"
                color="#FF2626"
                readonly
              >
                <template v-slot:prepend>
                  <v-icon color="#FF2626" title="0-6">
                    mdi-emoticon-sad
                  </v-icon>
                </template>

                <template v-slot:append>
                  <span class="font-weight-black black--text">
                    {{
                      (
                        visits.data[visits.data.length - 1].percent_detractors *
                        100
                      ).toFixed(1)
                    }}%
                  </span>
                </template>
              </v-slider>
            </v-col>
          </v-col>
        </v-row>
      </v-row>
    </v-col>
    <v-col cols="12">
      <v-row justify="center" align="center">
        <v-col lg="6" cols="12" sm="6" md="6">
          <LineChart
            v-if="!loading"
            :headers="monthNames"
            :defaultDataset="dataSource"
          />
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import LineChart from "../charts/LineChart.vue";
export default {
  name: "concersation_status",
  components: {
    LineChart,
  },
  data() {
    return {
      loading: false,
      availableMonths: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
      monthNames: [],
      dataSource: [
        {
          label: "Mean",
          data: [],
          fill: true,
          borderColor: "#FA6637",
          backgroundColor: "#e8c8be",
          borderWidth: 3,
        },
        {
          label: "NPS",
          data: [],
          fill: true,
          borderColor: "#5e8ef7",
          backgroundColor: "#c2d1f2",
          borderWidth: 3,
        },
        {
          label: "CES",
          data: [],
          fill: true,
          borderColor: "#939393",
          backgroundColor: "#ebe8e8",

          borderWidth: 3,
        },
      ],
    };
  },
  computed: {
    visits() {
      const data = this.$store.state.analytics.Rating;
      return data;
    },
  },
  async created() {
    if (this.visits) await this.init_vals();
  },
  methods: {
    retrieveDate(month_value, year) {
      return this.availableMonths[month_value - 1] + " - " + year;
    },
    init_vals() {
      for (let i = 0; i < this.visits.data.length; ++i) {
        const element = this.visits.data[i];
        this.monthNames.push(this.retrieveDate(element.month, element.year));
        this.dataSource[1].data.push(element.nps_score * 100);
        this.dataSource[2].data.push(element.ces_score * 100);
        this.dataSource[0].data.push(element.mean * 10);
      }
    },
    getArrow(inf, sup) {
      inf *= 100;
      sup *= 100;
      if (!inf || !sup) return "minus";
      if (inf < sup) {
        return "mdi-chevron-up-box";
      } else {
        if (inf.toFixed(1) === sup.toFixed(1)) {
          return "mdi-minus-box";
        }
        return "mdi-chevron-down-box";
      }
    },
  },
};
</script>
